import { createI18n } from 'vue-i18n'
import { resolveInitialLocale, supportedLocales } from './supportedLocales'
import { buildMessages } from './messages'
import english from './en.json'

// English is the fallback for every key, so it ships with the bundle and is
// cached across pages. The visitor's own locale is published by Rails on the
// page — see i18n/messages.ts for why it is not bundled alongside.
const available = supportedLocales()

const locale = resolveInitialLocale(
  typeof window === 'undefined' ? undefined : window.hiikerLocale,
  typeof document === 'undefined' ? undefined : document.documentElement.lang,
  available
)

export const i18n = createI18n({
  legacy: false, // Composition API mode
  // Rails already resolved the locale (user preference -> session ->
  // Accept-Language) and stamped it on the page, so start there rather than
  // re-deriving it from navigator.language and flashing the wrong language.
  locale,
  fallbackLocale: 'en',
  // A locale with no messages on the page still loads — vue-i18n falls back to
  // English per key, which is exactly what a part-translated locale needs.
  messages: buildMessages(
    english,
    typeof window === 'undefined' ? undefined : window.hiikerMessages,
    locale
  )
})

// Client-side half of a language change. The server half is POST /set_locale,
// which persists to users.locale (or the session when signed out); the caller
// does both, because Rails-rendered copy only changes on the next request.
//
// The new locale's messages are not on this page — Rails publishes one locale,
// the one it rendered — so the switch shows English until the reload the caller
// triggers. That is the same round trip the server-rendered copy needs anyway.
export const setLocale = (locale) => {
  if (!available.some((l) => l.code === locale)) return

  i18n.global.locale.value = locale
  document.documentElement.lang = locale
}

export default i18n
